import stores from 'bootstrap/store';
import { appFrameRouteStore } from '../../../domain/store';
const { router } = stores;

export default (tab) => {
  appFrameRouteStore.setValue('activeUserTypeTab', tab);
  router.history.push(appFrameRouteStore.defaultRedirectLink);
};
